/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CostreportV1beta1GetOrganizationOverviewResponse } from '../models';
/**
 * OrganizationOverviewAPIApi - axios parameter creator
 * @export
 */
export const OrganizationOverviewAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets organization overview using one click, cloud connect or snapshot data
         * @param {string} startTime Time range for metrics aggregation.
         * @param {string} endTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationOverviewAPIGetOrganizationOverview: async (startTime: string, endTime: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('organizationOverviewAPIGetOrganizationOverview', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('organizationOverviewAPIGetOrganizationOverview', 'endTime', endTime)
            const localVarPath = `/v1/cost-reports/organization/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationOverviewAPIApi - functional programming interface
 * @export
 */
export const OrganizationOverviewAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationOverviewAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets organization overview using one click, cloud connect or snapshot data
         * @param {string} startTime Time range for metrics aggregation.
         * @param {string} endTime 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationOverviewAPIGetOrganizationOverview(startTime: string, endTime: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1GetOrganizationOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationOverviewAPIGetOrganizationOverview(startTime, endTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationOverviewAPIApi.organizationOverviewAPIGetOrganizationOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationOverviewAPIApi - factory interface
 * @export
 */
export const OrganizationOverviewAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationOverviewAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets organization overview using one click, cloud connect or snapshot data
         * @param {OrganizationOverviewAPIApiOrganizationOverviewAPIGetOrganizationOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationOverviewAPIGetOrganizationOverview(requestParameters: OrganizationOverviewAPIApiOrganizationOverviewAPIGetOrganizationOverviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1GetOrganizationOverviewResponse> {
            return localVarFp.organizationOverviewAPIGetOrganizationOverview(requestParameters.startTime, requestParameters.endTime, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for organizationOverviewAPIGetOrganizationOverview operation in OrganizationOverviewAPIApi.
 * @export
 * @interface OrganizationOverviewAPIApiOrganizationOverviewAPIGetOrganizationOverviewRequest
 */
export interface OrganizationOverviewAPIApiOrganizationOverviewAPIGetOrganizationOverviewRequest {
    /**
     * Time range for metrics aggregation.
     * @type {string}
     * @memberof OrganizationOverviewAPIApiOrganizationOverviewAPIGetOrganizationOverview
     */
    readonly startTime: string

    /**
     * 
     * @type {string}
     * @memberof OrganizationOverviewAPIApiOrganizationOverviewAPIGetOrganizationOverview
     */
    readonly endTime: string
}

/**
 * OrganizationOverviewAPIApi - object-oriented interface
 * @export
 * @class OrganizationOverviewAPIApi
 * @extends {BaseAPI}
 */
export class OrganizationOverviewAPIApi extends BaseAPI {
    /**
     * 
     * @summary Gets organization overview using one click, cloud connect or snapshot data
     * @param {OrganizationOverviewAPIApiOrganizationOverviewAPIGetOrganizationOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationOverviewAPIApi
     */
    public organizationOverviewAPIGetOrganizationOverview(requestParameters: OrganizationOverviewAPIApiOrganizationOverviewAPIGetOrganizationOverviewRequest, options?: RawAxiosRequestConfig) {
        return OrganizationOverviewAPIApiFp(this.configuration).organizationOverviewAPIGetOrganizationOverview(requestParameters.startTime, requestParameters.endTime, options).then((request) => request(this.axios, this.basePath));
    }
}

